import { render } from "./StepTitle.vue?vue&type=template&id=56c66328&scoped=true&ts=true"
import script from "./StepTitle.vue?vue&type=script&lang=ts"
export * from "./StepTitle.vue?vue&type=script&lang=ts"

import "./StepTitle.vue?vue&type=style&index=0&id=56c66328&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c66328"]])

export default __exports__